import * as React from 'react';
import { Affix, AnalyticsProvider, AnalyticsTrigger, Button, Container, Grid, GridColumn, Notice } from 'telia-front-react';
import { useIsMobileHook } from './ThemeHooks';
import EnvironmentProvider from './EnvironmentProvider';
import LanguageProvider from './LanguageProvider';
import TranslationsContextWrapper from './TranslationsContextWrapper';
import { TranslationsContext } from '@teliaee/telia-translate';
const LOGIN_NOTICE_STORAGE_KEY = 'showLoginNotice';
const shouldShowNotice = (showNotice) => {
    return showNotice ? sessionStorage.getItem(LOGIN_NOTICE_STORAGE_KEY) !== 'false' : false;
};
export const LoginNotice = (props) => {
    const { language, tier, showNotice, ensureLogin, clientType, translations: customTranslations, disableTranslationsStatistics, isTestEnvironment } = props;
    const { isMobile } = useIsMobileHook();
    const [noticeShown, setNoticeShown] = React.useState(shouldShowNotice(showNotice));
    React.useEffect(() => {
        if (showNotice !== noticeShown) {
            setNoticeShown(shouldShowNotice(showNotice));
        }
    }, [showNotice]);
    const handleClose = () => {
        setNoticeShown(false);
        sessionStorage.setItem(LOGIN_NOTICE_STORAGE_KEY, 'false');
    };
    if (!noticeShown) {
        return null;
    }
    return (React.createElement(EnvironmentProvider, { app: "public", tier: tier },
        React.createElement(LanguageProvider, { lang: language },
            React.createElement(TranslationsContextWrapper, { disableStatistics: disableTranslationsStatistics, isTestEnvironment: isTestEnvironment },
                React.createElement(TranslationsContext.Consumer, null, ({ translate, translations }) => !!Object.keys(customTranslations || (translations === null || translations === void 0 ? void 0 : translations.iocc) || {}).length && (React.createElement(Affix, null,
                    React.createElement(Container, null,
                        React.createElement(AnalyticsProvider, { group: "Login notice" },
                            React.createElement(Notice, { id: "login-notice", type: "info", onCloseClick: handleClose, align: "center", fullWidth: true },
                                React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                                    React.createElement(GridColumn, { width: ['xs', 'max-sm'] },
                                        React.createElement("p", null, (customTranslations === null || customTranslations === void 0 ? void 0 : customTranslations.text) || translate(`loginNotice.text${clientType ? `.${clientType}` : ''}`))),
                                    React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                                        React.createElement(AnalyticsTrigger, { trigger: {
                                                id: 'Button - Login sisse',
                                                callback: 'onClick',
                                            } },
                                            React.createElement(Button, { text: (customTranslations === null || customTranslations === void 0 ? void 0 : customTranslations.cta) || translate('loginNotice.cta.text'), iconRight: "#arrow-right", size: isMobile ? 'small' : undefined, onClick: () => ensureLogin() }))))))))))))));
};
